import { StateBase } from './base/state-base';

export class State extends StateBase { }